import React, { Fragment } from "react";
import {
  List,
  Datagrid,
  Filter,
  TextInput,
  TextField,
  EditButton,
  BulkDeleteButton,
  DeleteButton,
  FunctionField,
  DateField,
} from "react-admin";
import { VideoTypeSelectInput } from "../../UI/Input/SelectInput";
import useCheckPermissions from '../AdminPermissions/useCheckPermissions'

const ListFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />

  </Filter>
);
const ListActionButtons = ({ ...props }) => {
  return (
    <>
      <BulkDeleteButton
        {...props}
        undoable={false}
        confirmTitle="Delete File Record"
        confirmContent={"Are you sure you want to delete this record?"}
      />
    </>
  );
};
const BasicSettingsList = ({ ...props }) => {
  return (
    <List
      {...props}
      title="Basic Plan"
      bulkActionButtons={<ListActionButtons />}
      filters={<ListFilter />}

    >
      <Datagrid rowClick={"show"}>
        <TextField source="id" />
        <TextField source="total_user_count_admin" label="User Count" />
        <TextField source="waiting_video_id" label="Waiting page Video Id" />
        <TextField source="demo_user_task_end_date" label="New usr Dmo Tsk E Date" />
        <TextField source="user_task_end_date" label="Old usr  Dmo Tsk E Date" />
        <TextField source="microtask_hashtag" label="Microtask verify Hashtag" />
        <TextField source="marketing_executive_hashtag" label="Marketing Executive verify Hashtag" />
        <TextField source="individual_marketer_hashtag" label="Individual Marketer verify Hashtag" />
        <TextField source="marketing_associate_hashtag" label="Marketing Associate verify Hashtag" />
        <TextField source="addontask_amount" label="addontask_amount" />
        <TextField source="video_code_start" label="Video Code Start" />
        <TextField source="video_code_end" label="Video Code End" />  

         {/* <TextField source="content_sharing_task_instruction" label="content_sharing_task_instruction Executive verify Hashtag" />
        <TextField source="content_reviewer_task_instruction" label="Content Reviewer Task Instruction" />
        <TextField source="media_booster_task_instruction" label="Media BoosterTask Instruction" />
         <TextField source="influencer_task_instruction" label="Influencer Task Instruction" /> */}


        {/* <TextField source="userwallet_min_amount" label="User Wallet Min Amount" />
            <TextField source="videowallet_min_amount" label="Video Wallet Min Amount" />
            <TextField source="admincharge" label="Admin Charge" />
            <TextField source="basic_user_refer_amount" label="Basic User Refer Amont" />
            <TextField source="primium_user_refer_amont" label="Primium User Refer Amont" /> */}

        {useCheckPermissions("BasicSetting_View") ? <EditButton /> : null}
        {useCheckPermissions("BasicSetting_Delete") ? <DeleteButton /> : null}
      </Datagrid>
    </List>
  );
};

export default BasicSettingsList;
